export default __webpack_public_path__ + "static/media/main.826656f1.jpg";